export default "__VITE_ASSET__BIM61mzs__"